// A rubber stamp slammed onto the card: "Only 23% got this", "Double points", "Lightning round".
// `charge` adds the defib-charge buzz after the slam (double points). Reduced motion: it fades in, tilted.
import { useEffect, useRef, type CSSProperties, type ReactNode } from 'react';
import { canAnimate, prefersReducedMotion } from '@/motion/reduced';

export type StampTone = 'cart' | 'brand' | 'iv' | 'wrong' | 'correct' | 'ink';

export function Stamp({ children, tone = 'cart', tilt = -6, animate = true, charge = false, className = '' }: {
  children: ReactNode; tone?: StampTone; tilt?: number; animate?: boolean; charge?: boolean; className?: string;
}) {
  const ref = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    const el = ref.current; if (!el || !charge || !canAnimate() || prefersReducedMotion()) return;
    const frames = Array.from({ length: 15 }, (_, i) => {
      const t = i / 14; const a = i === 14 ? 0 : 0.5 + 2.6 * t;
      return { transform: `rotate(${tilt}deg) translate3d(${i % 2 ? a : -a}px, ${i % 3 === 0 ? -a * 0.4 : a * 0.3}px, 0)`, offset: t };
    });
    const anim = el.animate(frames, { duration: 700, delay: animate ? 480 : 0, easing: 'linear' });
    return () => anim.cancel();
  }, [charge, tilt, animate]);
  return (
    <span ref={ref} className={`rd-stamp-mark ${animate ? 'rd-stamp' : ''} ${className}`} data-tone={tone} style={{ ['--rd-tilt' as string]: `${tilt}deg` } as CSSProperties}>
      {children}
    </span>
  );
}
